export const SET_FEEDBACK_WORKFLOW_AUTOMATION_LOADING = "SET_FEEDBACK_WORKFLOW_AUTOMATION_LOADING";
export const SET_FEEDBACK_WORKFLOW_AUTOMATION = "SET_FEEDBACK_WORKFLOW_AUTOMATION";
export const ADD_FEEDBACK_WORKFLOW_AUTOMATION = "ADD_FEEDBACK_WORKFLOW_AUTOMATION";
export const EDIT_FEEDBACK_WORKFLOW_AUTOMATION = "EDIT_FEEDBACK_WORKFLOW_AUTOMATION";